<template>
  <LayoutSearchFieldVertical
    display-variant="list"
  >
    <div class="facet-buttons">
      <button
        class="fb-button"
        v-for="(count, pro) in counts"
        :class="{
          'is-0': count === 0,
          'is-exclude': exclude,
          'is-selected': isSelected('+' + pro),
        }"
        @click="select(pro)"
        :key="pro"
      >
        <UiOrgProviderSpan class="fb-label" :id="pro">
          <template v-slot="{ org }">
            {{ display(org) }}
          </template>
        </UiOrgProviderSpan>
        <span class="fb-count" :title="num(count)">{{ nums(count) }}</span>
      </button>
    </div>

    <template #nav v-if="facet">
      <a @click="showAll()">{{
        lss('すべてを表示/複数を選択する', 'Show all/Multi select')
      }}</a>
    </template>

    <template #options v-if="facet">
      <BaseToggleSwitch class="is-red" v-model="exclude">{{
        lss('除外', 'Exclude')
      }}</BaseToggleSwitch>
      <SearchFieldProviderExpandModal
        ref="expand"
        :facet="facet"
        :ss="props.ss"
        :def="props.field"
      />
    </template>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import type { SearchFieldProviderExpandModal } from '#components'
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls, lss, nums, num } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet, excludeDisplay } = useSearchFieldBase(props)

const DATABASE_FACET_LEN = 10

const exclude: Ref<boolean> = ref(false)

const count = db => {
  if (!facet.value) return undefined
  return facet.value.counts[db] || 0
}

const select = (db: string) => {
  if (exclude.value) db = '-' + db
  else db = '+' + db
  if (isSelected(db)) {
    props.ss.removeFilter(props.field.key, [db])
  } else {
    props.ss.addFilter(props.field.key, [db])
  }
}

const isSelected = (db: string) => {
  return props.ss.state.filter[props.field.key]?.includes(db)
}

const display = (provider: Organization) => {
  if (provider) {
    let v = ls(provider.name)
    return excludeDisplay(v, exclude.value, count(provider.id))
  }
  return ''
}

const expand = ref<InstanceType<typeof SearchFieldProviderExpandModal>>()
const showAll = async () => {
  try {
    let selected = await expand.value.openAwait()
    if (exclude.value) selected = selected.map(s => s.replace('+', '-'))
    props.ss.setFilter(props.field.key, selected)
  } catch (cancel) {}
}

const counts = computed(() => {
  if (!facet.value) return {}
  const keys = Object.keys(facet.value.counts)
    .sort((a, b) => facet.value.counts[b] - facet.value.counts[a])
    .slice(0, DATABASE_FACET_LEN)
  let obj = {}
  keys.forEach(key => {
    obj[key] = facet.value.counts[key]
  })
  return obj
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.sf-provider {
  width: 100%;
  .facet-buttons {
    flex-direction: column;
  }

  .fb-button {
    width: 100%;
    flex-grow: 1;
  }
}
</style>
